// Recipient data to be used in the first version of bs_dialog
// WARNING! Not used anymore. Replaced by recipient

import { Component, Input, output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';
import { TooltipPosition, MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { Observable, Subscription } from 'rxjs';

import { StateService } from '../shared/state.service';
import * as dao from '../shared/dao';
import * as utils from '../shared/utils';

import * as constants from '../shared/constants';

@Component({
	selector: 'lib-beneficiaire',
	imports: [NgClass, MatTooltipModule, MatIconModule],
	templateUrl: './beneficiaire.component.html',
	styleUrls: ['./beneficiaire.component.scss', '../../../../fseclient/src/styles.scss', '../bs-dialog/bs-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: true,
})
export class BeneficiaireComponent {
	@Input() empreinteAdr: dao.EmpreinteAdr | undefined;	// Only for Adri
	@Input() beneficiaire: dao.Beneficiaire | undefined;
	@Input() pieceJustifAMO!: dao.PieceJustifAMO;
	@Input() pieceJustifAMC!: string;
	@Input() isDisabled!: boolean;
	@Input() isADR!: boolean;							// This occurence is displayded on ADR side
  @Input() sns!:dao.SituationNatures;

	public situationNature$: Observable<dao.SituationNatures> = this.stateService.situationNature$;
	
	public utils = utils;																							// Export to html view
	public constants = constants;
	public dao = dao;
	
	public activeblock?:number;
	//public situationNature: dao.SituationNature = new dao.SituationNature(undefined, undefined, undefined);
	public snindex: number = 0;
	
	constructor(private stateService: StateService){};

	/*
	ngOnInit() {
	  //console.log(`[BeneficiaireComponent.ngOnInit] isADR - beneficiaire?.periodeDroitsAMO: ${this.isADR} - ${this.beneficiaire?.periodeDroitsAMO}`);
		this.situationNature$.subscribe((sns:dao.SituationNatures) => {
			console.log('[BeneficiaireComponent] SituationNatures changed: ', JSON.stringify(sns));
		})
	}
	*/
	
	ngOnChanges(changes: SimpleChanges) {
	  if (changes['dateFacture$'] && changes['dateFacture$'].currentValue) {
			//console.log('Subscribing to dateFacture$');
	    //this.subscribeToDateFacture();
	  }
		
		if (changes['beneficiaire']) {
			console.log('[BeneficiaireComponent - change beneficiaire]');
		}

		if (changes['isADR']) {
			this.snindex = (this.isADR ? 1 : 0);
		}
	}
	
	// Indicateur de prise en commpte AMO
	get isGreenBorderAMO(): boolean {
	  return (!this.isADR && this.pieceJustifAMO === dao.PieceJustifAMO.CARTE_VITALE) || ([dao.PieceJustifAMO.ADR, dao.PieceJustifAMO.APCV].includes(this.pieceJustifAMO) && this.isADR );
	}	
	
  // Indicateur de prise en commpte AMC
	get isGreenBorderAMC(): boolean {
	  return (!this.isADR && this.pieceJustifAMC === '4') || ([dao.PieceJustifAMO.ADR, dao.PieceJustifAMO.APCV].includes(this.pieceJustifAMO) && this.isADR );
	}	
	
	get isSP082(): boolean {	// Detect "BS permanent coordonné RSS" ex « autre situation de migrant »  FACT-SFG-012 BS [RG_BS314] [SP08.2]
		return false;	
	}
	
	ngOnDestroy() {
	  // Clean up the subscription to avoid memory leaks
/*	  if (this.subscription) {
	    this.subscription.unsubscribe();
	  }*/
	}
}
